import { render, staticRenderFns } from "./banners.vue?vue&type=template&id=c39c7b84&scoped=true"
import script from "./banners.vue?vue&type=script&lang=js"
export * from "./banners.vue?vue&type=script&lang=js"
import style0 from "./banners.vue?vue&type=style&index=0&id=c39c7b84&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c39c7b84",
  null
  
)

export default component.exports